import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { useContext } from 'react';
import PropTypes from "prop-types";
import FeatherIcon from "../feather-icon/FeatherIcon";
import { ContextMenuContext } from "./ContextMenu";
import * as stylex from '@stylexjs/stylex';
import Icon from "noood/comp/ui/feather-icon/Icon";
export default function ContextMenuItem(props) {
  var contextMenuContext = useContext(ContextMenuContext);
  return /*#__PURE__*/React.createElement("li", _extends({
    onClick: function onClick() {
      var _contextMenuContext$_, _props$__valueExtract;
      contextMenuContext === null || contextMenuContext === void 0 || (_contextMenuContext$_ = contextMenuContext.__collect) === null || _contextMenuContext$_ === void 0 || _contextMenuContext$_.call(contextMenuContext, props.value);
      (_props$__valueExtract = props.__valueExtractor) === null || _props$__valueExtract === void 0 || _props$__valueExtract.call(props, props.value);
    }
  }, stylex.props(ui.base, props.isLast && ui.last_item)), props.icon && /*#__PURE__*/React.createElement(Icon, {
    style: {
      marginRight: '5px'
    },
    icon: props.icon,
    color: "var(--shade-70)"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ContextMenuItem__ui.label ev4z9k3i ev5ea3kt"
  }, props.label), props.selected && /*#__PURE__*/React.createElement("div", {
    style: {
      "float": 'right'
    }
  }, /*#__PURE__*/React.createElement(FeatherIcon, {
    icon: 'check',
    style: {
      color: 'green'
    }
  })));
}
ContextMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  selected: PropTypes.bool,
  isLast: PropTypes.bool,
  value: PropTypes.string,
  __valueExtractor: PropTypes.func,
  __onMount: PropTypes.func
};
_inject(".ev1m3phxg{transition:background-color .1s}", 2000);
_inject(".ev11ycvst{background-color:var(--shade)}", 3000);
_inject(".evotx0s4:hover{background-color:var(--shade-light)}", 3130);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".ev5t5jma{padding:4px 7px}", 1000);
_inject(".evd0eoby{border-bottom:1px solid var(--shade-05)}", 2000);
_inject(".ev4z9k3i{font-size:13px}", 3000);
_inject(".ev5ea3kt{color:var(--shade-70)}", 3000);
_inject(".evaqea5y{border-bottom:0}", 2000);
var ui = {
  base: {
    "ContextMenuItem__ui.base": "ContextMenuItem__ui.base",
    transition: "ev1m3phxg",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    backgroundColor: "ev11ycvst evotx0s4",
    cursor: "ev1ypdohk",
    padding: "ev5t5jma",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderBottom: "evd0eoby",
    borderBottomWidth: null,
    borderBottomStyle: null,
    borderBottomColor: null,
    $$css: true
  },
  last_item: {
    "ContextMenuItem__ui.last_item": "ContextMenuItem__ui.last_item",
    borderBottom: "evaqea5y",
    borderBottomWidth: null,
    borderBottomStyle: null,
    borderBottomColor: null,
    $$css: true
  }
};